module.exports = __webpack_public_path__ + "static/dashboard-ed147da9d10b04d49ff46497f38fdeb9.png";